import React, { type ReactElement } from "react";
import type { MenuItemProps } from "react-aria-components";

import { MenuDesktop } from "@/components/ui/Menu/MenuDesktop";
import { MenuMobile } from "@/components/ui/Menu/MenuMobile";
import { useBreakpoint } from "@/hooks/useBreakpoint";

export interface MenuItem extends Omit<MenuItemProps, "aria-label" | "textValue" | "children"> {
  label: string;
  content?: string | ReactElement;
  children?: MenuItem[];
}

export interface MenuProps {
  trigger: ReactElement;
  items: MenuItem[];
  triggerClassName?: string;
}
export const Menu = (props: MenuProps) => {
  const isDesktop = useBreakpoint("t");

  if (isDesktop) {
    return <MenuDesktop {...props} />;
  }

  return <MenuMobile {...props} />;
};
